import type { ToolRendererProps } from '@/config/types'

export type GeneratedImageRef = {
  attachmentId: string
  name: string
  mimeType?: string
  url?: string
  s3Key?: string
  size?: number
}

export type ImageToolResult = {
  model?: string
  prompt?: string
  error?: string
  images: GeneratedImageRef[]
}

export const coerceImageResult = (call: ToolRendererProps['call']): ImageToolResult => {
  const raw = (call.output ?? {}) as any
  const images: GeneratedImageRef[] = Array.isArray(raw.images)
    ? raw.images
        .map((image: any) => ({
          attachmentId: typeof image?.attachmentId === 'string' ? image.attachmentId : '',
          name: typeof image?.name === 'string' ? image.name : 'generated-image',
          mimeType: typeof image?.mimeType === 'string' ? image.mimeType : undefined,
          url: typeof image?.url === 'string' ? image.url : undefined,
          s3Key: typeof image?.s3Key === 'string' ? image.s3Key : undefined,
          size: typeof image?.size === 'number' ? image.size : undefined
        }))
        .filter((image: GeneratedImageRef) => image.attachmentId.length > 0)
    : []

  return {
    model: typeof raw.model === 'string' ? raw.model : undefined,
    prompt: typeof raw.prompt === 'string' ? raw.prompt : undefined,
    error: typeof raw.error === 'string' ? raw.error : undefined,
    images
  }
}
